import React from 'react';
import { useSelector } from 'react-redux';
import { Loading } from '@salesperformanceint/e4shared';

import PathwayDetails from 'components/prism/pathwayDetails';
import { apiGet } from 'services';

export const PathwayDetail = ({ pathwayId, profile }) => {
    const [data, setData] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        setLoading(true);
        apiGet(`pathway-library/${pathwayId}/${profile.id}`, user.guid, response => {
            setData(response);
            setLoading(false);
        });
    }, [pathwayId]);

    if (loading) return <Loading />;

    return (
        <div className="mt20">
            <PathwayDetails data={data} hideBullet managerView />
        </div>
    );
};

export default PathwayDetail;
